import * as React from "react";
const NativeApp = (props) => (
  <svg
    id="Layer_5"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        "\n                        .st0 {\n                          fill: #2D2D2D;\n                        }\n\n                        .st1 {\n                          fill: #70B4C6;\n                        }\n                      "
      }
    </style>
    <g>
      <g>
        <g>
          <path className="st0" d="M184,152h-64v-48h64V152z" />
        </g>
      </g>
      <g>
        <g>
          <path className="st0" d="M264,152h-64v-48h64V152z" />
        </g>
      </g>
      <g>
        <g>
          <path className="st0" d="M184,216h-64v-48h64V216z" />
        </g>
      </g>
      <g>
        <g>
          <path className="st0" d="M264,216h-64v-48h64V216z" />
        </g>
      </g>
      <g>
        <g>
          <path className="st0" d="M184,280h-64v-48h64V280z" />
        </g>
      </g>
      <g>
        <g>
          <path
            className="st0"
            d="M364,176c-11,0-20-9-20-20v-4h-17.8c-16.8,0-31.3-11.4-35.4-27.6l-9.8-39c-0.7-2.9-1.1-5.9-1.1-8.8                       c0-20.1,16.4-36.5,36.5-36.5h151c20.1,0,36.5,16.4,36.5,36.5c0,3-0.4,5.9-1.1,8.8l-9.8,39c-4.1,16.3-18.6,27.6-35.4,27.6h-55.1                       L376,172C372.6,174.6,368.3,176,364,176L364,176z"
          />
        </g>
      </g>
      <g>
        <path
          className="st1"
          d="M264,376h-16c-8.8,0-16,7.2-16,16v8c0,13.2,10.8,24,24,24s24-10.8,24-24v-8C280,383.2,272.8,376,264,376z                       M264,400c0,4.4-3.6,8-8,8s-8-3.6-8-8v-8h16V400z"
        />
        <path className="st1" d="M328,72h128v16H328V72z" />
        <path className="st1" d="M440,104h16v16h-16V104z" />
        <path className="st1" d="M328,104h96v16h-96V104z" />
        <path
          className="st1"
          d="M507.3,368L456,316.7v-18.2c0-19.2-7.5-37.3-21.1-50.9l-48.3-48.3c-4.6-4.6-11.1-7.3-17.7-7.3                     c-10.2,0-18.9,6.2-22.8,14.9c-4.6-4.4-10.8-6.9-17.2-6.9c-0.3,0-0.6,0.1-1,0.1V152h-1.8c-5,0-9.8-1.1-14.2-3v57.8                     c-4.7,4.4-7.7,10.5-7.9,17.3c-2.8,0.1-5.6,0.7-8.1,1.6v-89.8c-2.3-3.4-4.1-7.3-5.2-11.5l-9.8-39c-0.7-2.9-1.1-5.9-1.1-8.8                     c0-1.4,0.3-2.8,0.4-4.2H88v293.4c-1,2.2-2,4.4-3.1,6.6c-1.2,2.3-3.5,3.8-6.1,3.8c-3.8,0-6.8-3.1-6.8-6.8V48.3                     c0-13.2,10.8-24,24-24h40v8c0,13.2,10.8,24,24,24h64c13.2,0,24-10.8,24-24v-8h40.3c10.4,0,19.2,6.9,22.4,16.3                     c1.9-0.3,3.8-0.6,5.8-0.6h10.7c-3.7-18.1-19.7-31.7-38.9-31.7H96c-22.1,0-40,17.9-40,40v188.4l-22.1,22.1                     C17.2,275.5,8,297.7,8,321.3c0,4.8,0.4,9.7,1.2,14.5l12.4,74.7c1.7,10.3,4.6,20.6,8.5,30.3l9.9,24.7V504h112v-38.5l3.8-9.5H288                     c22.1,0,40-17.9,40-40v-17.7c5,1.1,10,1.7,15.2,1.7h29.5l51.3,51.3L507.3,368z M232,32.3c0,4.4-3.6,8-8,8h-64c-4.4,0-8-3.6-8-8v-8                     h80V32.3z M104,88.3h176v152.8l-37.8-34.6c-4.6-4.2-10.5-6.5-17.5-6.5c-13.6,0-24.7,11.1-24.7,24.7c0,6.8,2.9,13.5,7.9,18.1                     l65.9,61.2c-0.3,0-0.6,0-0.9,0c-12.6,0-24.9,3.7-35.4,10.7l-3,2c-6.6,4.4-10.5,11.7-10.5,19.7c0,2.7,0.5,5.2,1.4,7.6h-61l-3-39.3                     c-1.1-13.8-12.8-24.7-26.7-24.7c-12.3,0-23,8.3-25.9,20.3L104,319L104,88.3z M167.8,392H200c0,8.8-7.2,16-16,16h-16.5                     c0.3-3.5,0.5-7.1,0.5-10.7C168,395.5,167.9,393.8,167.8,392z M25,333.3c-0.7-3.9-1-7.9-1-11.9c0-19.4,7.5-37.6,21.2-51.3L56,259.3                     v109.9c0,12.6,10.2,22.8,22.8,22.8c8.7,0,16.5-4.8,20.4-12.6c8.2-16.3,14.5-33.6,19-51.3l6-24c1.2-4.8,5.5-8.1,10.4-8.1                     c5.6,0,10.3,4.4,10.7,9.9l6.3,81.4c0.3,3.3,0.4,6.7,0.4,10c0,16.7-3.1,33-9.3,48.5l-4.1,10.2H53.4L45,434.9                     c-3.5-8.7-6-17.8-7.6-27L25,333.3z M136,488H56v-16h80V488z M312,416c0,13.2-10.8,24-24,24H161.6c1.6-5.3,2.9-10.6,3.9-16H184                     c17.6,0,32-14.4,32-32c0-8.8-7.2-16-16-16h-33.2l-1.2-16h82.1h1.2c13.1,0,25.8,4.6,35.8,13l12.4,10.3c4.6,3.8,9.6,7,14.9,9.5                     L312,416L312,416z M307.3,371l-12.4-10.3C282,349.9,265.6,344,248.8,344h-1.2c-4.2,0-7.6-3.4-7.6-7.6c0-2.6,1.3-4.9,3.4-6.4l3-2                     c7.9-5.2,17-8,26.5-8c10.1,0,19.6,3.1,27.7,8.9l14,13l5.4-5.9l5.7-5.7l-7.7-7.7c-2.2-2.2-4.6-4.2-7.1-6l-92.2-85.6                     c-1.8-1.6-2.8-4-2.8-6.4c0-4.8,3.9-8.7,9.5-8.7c2.2,0,4.3,0.8,5.9,2.3l91.2,83.6l5.4-5.9l5.7-5.7l-35-35c-1.7-1.7-2.6-3.9-2.6-6.3                     c0-4.9,4-9,9-9c2.4,0,4.7,1,6.3,2.6l35,35l11.3-11.3l-35-35c-1.7-1.7-2.6-3.9-2.6-6.3c0-4.9,4-9,9-9c2.4,0,4.7,1,6.3,2.6l16,16                     l19,19l11.3-11.3l-19-19c-1.7-1.7-2.6-3.9-2.6-6.3c0-4.9,4-9,9-9c2.4,0,4.7,1,6.3,2.6l48.3,48.3c10.6,10.6,16.4,24.6,16.4,39.6                     v18.2L372.7,384h-29.5C330.1,384,317.4,379.4,307.3,371L307.3,371z M448,331.3l36.7,36.7L424,428.7L387.3,392L448,331.3z"
        />
      </g>
    </g>
  </svg>
);
export default NativeApp;
